export default "__VITE_ASSET__Bmr$lnv7__"